import type {
	SuperAdminRouter,
	SuperAdminRouterOutputs,
} from "@backend/routers/super_admin/super_admin.router";
import { createORPCClient, onError } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { SimpleCsrfProtectionLinkPlugin } from "@orpc/client/plugins";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiBase } from "@superadmin/configs/env.config";

// `new URL(path, base)` inside RPCLink needs an absolute base, so resolve
// the same-origin case against window.location explicitly.
const baseUrl = `${apiBase || window.location.origin}/super-admin/rpc`;

const link = new RPCLink({
	url: baseUrl,
	fetch: (request, init) =>
		globalThis.fetch(request, { ...init, credentials: "include" as const }),
	interceptors: [
		onError((error) => {
			const err = error as { name?: string; message?: string };
			if (err.name === "AbortError") return;
			console.error("[superadmin oRPC]", err.message ?? error);
		}),
	],
	plugins: [new SimpleCsrfProtectionLinkPlugin()],
});

export const orpcFetch: SuperAdminRouter = createORPCClient(link);
export const orpc = createTanstackQueryUtils(orpcFetch);

export type SuperAdminOutputs = SuperAdminRouterOutputs;
